import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LanguageService, Language } from '../../services/language.service';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.css']
})
export class ModalHeaderComponent implements OnInit {

  @Input() headerTitle: string;
  @Output() languageSelected: EventEmitter<Language> = new EventEmitter();
  public currentLanguageCode = "eng";
  public currentLanguage: Language;

  public languages: Language[];

  constructor(
    private languageSvc: LanguageService,
    private apiSvc: ApiService,
  ) { }

  ngOnInit() {

    this.loadLanguages();

  }

  private loadLanguages() {

    console.log("LOADING LANGUAGES");
      this.languageSvc.loadLanguages().then(
        (data) => {
          this.languages = data;
          this.setSelectedLanguage();
          console.log("Languages:", this.languages);
        }
      ).catch((err) => {
        alert("Error while getting the languages"); //TODO this is temp
        console.log(err);
      });

  }

  public changeLanguage() {
    //  console.log("Change language", this.currentLanguage);
      this.setSelectedLanguage();
    }

  private setSelectedLanguage() {

    if (this.languages === null) {return};

    console.log("modalHeader.setSelectedLangage", this.currentLanguageCode);
    var result = this.languages.filter((item) => {return item.Code === this.currentLanguageCode });
    if (result.length === 1) {
      // console.log("setSelectedLangage Found", result[0]);
       this.currentLanguage = result[0];
       this.languageSelected.emit(this.currentLanguage);
    }

    return;

  }

}
